<template>
  <div class="land-footer">
    <div class="land-footer-link">
      <div
        class="footer-link-logo"
        @click="toTop"
      >
        <router-link to="/"><img :src="logo2"></router-link>
      </div>
      <div class="footer-link-solution">
        <div class="link-solution-title">解决方案</div>
        <div
          class="link-solution-text"
          v-for="(item, index) in solutionList"
          :key="index"
          @click="toTop"
        >
        <a
            :href="item.referringSite"
          >{{item.text}}</a>
          <!-- <router-link :to="{path:item.referringSite}">{{item.text}}</router-link> -->
        </div>
      </div>
      <div class="footer-link-partner">
        <div class="link-partner-title">友情链接</div>
        <div
          class="link-partner-text"
          v-for="(item, index) in linkList"
          :key="index"
        ><a
            :href="item.referringSite"
            target="_blank"
          >{{item.text}}</a></div>
      </div>
      <div class="footer-link-contact">
        <div class="link-contact-title">联系我们</div>
        <div class="link-contact-phone">咨询电话 4000-166-166</div>
        <div class="link-contact-address">地址：中国-北京-海淀区西北旺东路10号院东区13号楼广联达信息大厦</div>
      </div>
    </div>
    <div class="land-footer-copyright">
      <div>Copyright @ Glodon Company Limited 1998-2024 All Rights Reseved ｜ 经营性网站备案信息 京ICP备10021606号-1
        京公网安备11010802021391号</div>
    </div>
  </div>
</template>

<script>
import { getBottomLinkList } from '@/api/landing'
import { scrollTopFun } from '@/utils/universalFun.js'
const staticLogo2 = require('../../../../assets/images/browser/img/logo2.png')
export default {
  name: 'landFooter',
  mounted () {
    this.getList()
  },
  data () {
    return {
      logo2: staticLogo2,
      solutionList: [],
      linkList: []
    }
  },
  methods: {
    // 获取列表
    getList () {
      getBottomLinkList().then(res => {
        const { code, data, message } = res
        if (code === 200) {
          for (let index = 0; index < data.length; index++) {
            if (data[index].type === 'solution') {
              this.solutionList.push(data[index] || [])
            } else if (data[index].type === 'link') {
              this.linkList.push(data[index] || [])
            }
          }
        } else {
          this.PartnerList = []
          message && this.$message.error(message)
        }
      }).catch(() => {
        this.BottomLinkList = []
      })
    },
    toTop () {
      // 回到顶部
      scrollTopFun()
    }
  }
}
</script>

<style lang="scss" scoped>
.land-footer {
  margin: auto;
  height: 308px;
  color: #ffffff;
  background: #0e1726;

  a {
    text-decoration: none;
    color: #ffffffb3;
  }
  a:hover {
    color: #4499ff;
  }
  .land-footer-link {
    width: 1200px;
    height: 242px;
    margin: auto;
    display: flex;

    .footer-link-logo {
      width: 198px;
      height: 100px;
      margin: auto 229px auto 0px;
      //取消竖线，内容不能被选择
      -webkit-user-select: none; /*谷歌 /Chrome*/
      -moz-user-select: none; /*火狐/Firefox*/
      -ms-user-select: none; /*IE 10+*/
      user-select: none;
      img {
        width: 198px;
        height: 100px;
        object-fit: contain;
      }
    }

    .footer-link-solution {
      width: 242px;
      margin-top: 51px;
      .link-solution-title {
        font-size: 16px;
        font-weight: normal;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 14px;
      }

      .link-solution-text {
        // width: 140px;
        font-size: 14px;
        font-weight: normal;
        color: #ffffffb3;
        line-height: 28px;
      }
    }

    .footer-link-partner {
      width: 258px;
      margin-top: 51px;
      .link-partner-title {
        font-size: 16px;
        font-weight: normal;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 14px;
      }

      .link-partner-text {
        font-size: 14px;
        font-weight: normal;
        color: #ffffffb3;
        line-height: 28px;
      }
    }

    .footer-link-contact {
      width: 309px;
      margin-top: 51px;

      // background-color: rgb(67, 58, 45);
      .link-contact-title {
        font-size: 16px;
        font-weight: normal;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 8px;
      }

      .link-contact-phone {
        font-size: 14px;
        font-weight: normal;
        color: #ffffffb3;
        line-height: 32px;
        margin-bottom: 12px;
      }

      .link-contact-address {
        font-size: 14px;
        font-weight: normal;
        color: #ffffffb3;
        line-height: 21px;
      }
    }
  }

  .land-footer-copyright {
    height: 65px;
    margin: auto 0px auto 0px;
    border-top: 1px solid #ffffff29;

    div {
      // width: 1089px;
      width: 100%;
      text-align: center;
      margin: auto;
      font-size: 14px;
      font-weight: 400;
      color: #ffffffb3;
      line-height: 65px;
    }
  }
}
</style>
